import { Flex, Grid, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './Location.module.css';
import image from '../../../../../assets/icons/shop.svg';
import { onboardingLocations, ownLocations } from './constants';
import { OpenMapBtn } from './OpenMapBtn';

type OwnLocation = {
  name: string;
  street: string;
  city: string;
  mapLink: string;
  note?: string;
};

const LocationCard = ({ location }: { location: OwnLocation }) => (
  <Flex direction="column" gap="8px" className={classes.content}>
    <Flex className={classes.locationIcon}>
      <img src={image} alt="Location Icon" width={23} height={23} />
    </Flex>
    <Text className={classes.ownLocationTitle}>{location.name}</Text>
    <Flex direction="column">
      <Text className={classes.locationDesc}>{location.street}</Text>
      <Text className={classes.locationDesc}>{location.city}</Text>
      {location.note && (
        <Text className={classes.locationDesc} mt="4px">
          {location.note}
        </Text>
      )}
    </Flex>
    <OpenMapBtn link={location.mapLink} />
  </Flex>
);

export const OwnLocations = () => {
  const { t } = useTranslation('landingpage');
  return (
    <Flex className={classes.locationsContainer}>
      <Grid w="100%">
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <Text className={classes.ownLocationGroupTitle}>
            {t('Locations.OnboardingCenter')}
          </Text>
          <Grid>
            {onboardingLocations.map((location, index) => (
              <Grid.Col key={index} span={12}>
                <LocationCard location={location} />
              </Grid.Col>
            ))}
          </Grid>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <Text className={classes.ownLocationGroupTitle}>
            {t('Locations.OurSalesOutlets')}
          </Text>
          <Grid>
            {ownLocations.map((location, index) => (
              <Grid.Col key={index} span={12}>
                <LocationCard location={location} />
              </Grid.Col>
            ))}
          </Grid>
        </Grid.Col>
      </Grid>
    </Flex>
  );
};
